import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PropTypes from "prop-types";
export default function ConfirmationDialog(props) {
  const {
    onClose,
    onSubmit,
    open,
    messageBody,
    teamBallotDashboard,
    dialogTitle,
    ...other
  } = props;

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onSubmit();
  };

  return (
    <Dialog
      // sx={
      //   teamBallotDashboard
      //     ? {
      //         "& .MuiDialog-paper": {
      //           position: "absolute",
      //           top: "48%",
      //           left: window.innerWidth <= 769 ? "40vw" : "48%",
      //           transform: "translate(-50%, -50%)",
      //           width: window.innerWidth <= 769 ? "70vw" : "90vw",
      //           height: "80vh",
      //           bgcolor: "background.paper",
      //           borderRadius: "6px",
      //           p: 2,
      //         },
      //       }
      //     : {
      //         "& .MuiDialog-paper": {
      //           width: "80%",
      //           maxHeight: 435
      //         },
      //       }
      // }
      maxWidth={teamBallotDashboard ? "lg" : "sm"}
      fullWidth={teamBallotDashboard ? true : false}
      open={open}
      {...other}
    >
      <DialogTitle sx={{ backgroundColor: "#1d428a", color: "#fff" }}>
        {dialogTitle ? dialogTitle : "Confirmation"}
      </DialogTitle>
      <DialogContent
        dividers
        sx={
          teamBallotDashboard
            ? {
                overflow: "auto",
                overflowY: "hidden",
                height: "100%",
              }
            : {}
        }
      >
        {messageBody
          ? messageBody
          : `Are you sure you want to perform this operation?`}
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          autoFocus
          variant="contained"
          onClick={handleCancel}
          color="secondary"
        >
          Cancel
        </Button>
        <Button size="small" variant="contained" onClick={handleOk}>
          {teamBallotDashboard ? "Confirm" : "Yes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
